import React from 'react';
import { formatDecimal } from '../../util/format-decimal';
import { YesNoRadio } from '../../index';
import { AddFunnelPropFromContext } from '../funnel-context';
import { LABELS as DEFAULT_LABELS, INTERNATIONAL_FUNNELS, FUNNELS } from '../../util/constants';
import { defaultFieldPropTypes } from '../../types';
import { Stack } from '@nib/layout';
import Copy from '@nib-components/copy';
import { StandardInfoBox } from '../info-box';
const LABELS = {
  ARHI: DEFAULT_LABELS.MEDICARE_ALL_COVERED_RADIO_LABEL
};
const MedicareAllCoveredRadio = props => {
  const {
    id = 'medicareAllCoveredRadio',
    values,
    funnel = FUNNELS.ARHI,
    help = '',
    width = 20,
    optional = false,
    newPrice
  } = props;
  const radioSelected = Boolean(values && values[id] && values[id].length);
  const showPriceChangeNotification = !INTERNATIONAL_FUNNELS.includes(funnel);
  const showInfoBoxMessage = Boolean(values && values[id] && values[id] === 'no');
  return React.createElement(Stack, {
    space: 2
  }, React.createElement(YesNoRadio, {
    ...props,
    label: props.label || LABELS[funnel] || LABELS.ARHI,
    funnel: funnel,
    width: width,
    help: help,
    optional: optional
  }), showInfoBoxMessage && React.createElement(StandardInfoBox, {
    withTip: true
  }, React.createElement(Copy, null, "If any person listed on this policy is not covered by Medicare, we're unable to apply the Australian Government Rebate.")), showPriceChangeNotification && radioSelected && newPrice && React.createElement(StandardInfoBox, {
    role: "status",
    withTip: !showInfoBoxMessage
  }, React.createElement(Copy, null, "Your price has been updated to reflect your changed Australian Government Rebate details. ", React.createElement("strong", null, "New price $", formatDecimal(newPrice, {
    places: 2,
    separator: ','
  }), "*."))));
};
MedicareAllCoveredRadio.defaultProps = {
  ...defaultFieldPropTypes
};
const MedicareAllCoveredRadioWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, React.createElement(MedicareAllCoveredRadio, {
  ...props
}));
export default MedicareAllCoveredRadioWithFunnel;